import React, { useState, useRef, useContext } from 'react';
import { TemplateContext } from '../layout';
import formatCurrency from '../func/currency_formatter';
import arrow from '/fallbacks/arrow-dark.svg';
import summaryIconFallback from '/fallbacks/summary.svg';
import savingsIconFallback from '/fallbacks/discount-sharp.svg';

const OrderSummary = () => {
	const summaryConfig = window.post_template?.checkout_v3_summary;
	const [templateContext] = useContext(TemplateContext);
	const formattedString = window.formattedString;
	const [expanded, setExpanded] = useState(false);

	const accardionInnerWrap = useRef(null);

	const toggleSummary = () => {
		setExpanded(!expanded);
	};

	const warrantyPrice =
		templateContext?.config?.warrantyState == true
			? Number(templateContext?.config?.product?.warranty_price) * Number(templateContext?.config?.product?.amount)
			: 0;
	const productsPrice = templateContext?.config?.warrantyState
		? Number(templateContext?.config?.product?.amount) * Number(templateContext?.config?.product?.price)
		: Number(templateContext?.config?.product?.amount) * Number(templateContext?.config?.product?.price);
	const shippingPrice = Number(templateContext?.config?.product?.shipping_price);
	const oldPrice = Number(templateContext?.config?.product?.old_price);
	const savings = Number(oldPrice - productsPrice).toFixed(2);

	// calculated
	const totaloldPriceFormated = formattedString
		? formattedString.replace(/0.00|0,00/g, Number(oldPrice + warrantyPrice).toFixed(2))
		: formatCurrency(oldPrice + warrantyPrice);
	const totalPriceFormated = formattedString
		? formattedString.replace(/0.00|0,00/g, Number(productsPrice + warrantyPrice).toFixed(2))
		: formatCurrency(productsPrice);
	const shippingPriceFormated = formattedString
		? formattedString.replace(/0.00|0,00/g, Number(shippingPrice).toFixed(2))
		: formatCurrency(shippingPrice);
	const savingsFormated = formattedString
		? formattedString.replace(/0.00|0,00/g, Number(savings).toFixed(2))
		: formatCurrency(savings);
	const total = formattedString
		? formattedString.replace(/0.00|0,00/g, Number(productsPrice + shippingPrice + warrantyPrice).toFixed(2))
		: formatCurrency(productsPrice + shippingPrice + warrantyPrice);
	// Static Textual Content

	const orderSummaryLabel = summaryConfig.tr_checkout_v3_summary_orderLabel;
	const shippingLabel = summaryConfig.tr_checkout_v3_summary_shippingLabel;
	const warrantyLabel = summaryConfig.tr_checkout_v3_summary_warrantyLabel;
	const totalLabel = summaryConfig.tr_checkout_v3_summary_totalLabel;
	const shippingDuration = summaryConfig.tr_checkout_v3_summary_shippingDur;
	const savingsLabel = summaryConfig.tr_checkout_v3_summary_savingsLabel;
	const protectionLabel = summaryConfig.tr_checkout_v3_summary_protectionLabel;

	// icon
	const summaryIcon = summaryConfig.checkout_v3_summary_icon
		? summaryConfig.checkout_v3_summary_icon
		: summaryIconFallback;
	const savingsIcon = summaryConfig.checkout_v3_summary_iconSavings
		? summaryConfig.checkout_v3_summary_iconSavings
		: savingsIconFallback;

	// colors

	const savingsBackground = summaryConfig.checkout_v3_summary_savingsBackground;
	const backgroundColor = summaryConfig.checkout_v3_summary_background;
	const textColor = summaryConfig.checkout_v3_summary_color;
	const savingsColor = summaryConfig.checkout_v3_summary_savingsTextColor;

	return (
		<div
			className="summary"
			onClick={() => {
				toggleSummary();
			}}
			style={{ backgroundColor: backgroundColor }}
		>
			<div className="summary__innerWrap">
				<h2 className="heading-2 heading-2--noBorder" style={{ backgroundColor: backgroundColor }}>
					<span
						className="heading-2__img"
						style={{
							backgroundImage: `url(${summaryIcon})`,
							position: 'relative',
							top: '-1px',
						}}
					></span>
					<span className="heading-2__text" style={{ color: textColor, display: 'flex', alignItems: 'center' }}>
						{orderSummaryLabel}
						<div
							className={` ${expanded ? 'summary__arrow summary__arrow--active' : 'summary__arrow'}`}
							style={{ backgroundImage: `url(${arrow})` }}
						></div>
					</span>
				</h2>

				<div
					className={`${expanded ? 'summary__total summary__total--active' : 'summary__total'}`}
					style={{ color: textColor }}
				>
					{total}
				</div>
			</div>
			<div
				className="summary__data"
				ref={accardionInnerWrap}
				style={{ height: '100%', maxHeight: `${expanded ? 400 : 0}px`, paddingBottom: expanded && '16px' }}
			>
				<div className="summary__name" style={{ color: textColor }}>
					<span>
						{templateContext?.config?.product?.amount} x {templateContext?.config?.product?.display_name}{' '}
						{templateContext?.config?.warrantyState && `+ ${protectionLabel}`}
					</span>

					<span style={{ color: textColor }}>
						{' '}
						<s className="summary__oldPrice">{totaloldPriceFormated}</s>
						{totalPriceFormated}
					</span>
				</div>
				<div className="summary__shipping" style={{ color: textColor }}>
					<span>
						{shippingLabel}
						{shippingDuration}
					</span>
					<span>{shippingPriceFormated}</span>
				</div>
				<div className="summary__totalBottom summary__totalBottom--bold" style={{ color: textColor }}>
					<span>{totalLabel}</span>
					<b>
						<span>{total}</span>
					</b>
				</div>
			</div>
			<div className="summary__savings" style={{ backgroundColor: savingsBackground }}>
				<h2 className="heading-2 heading-2--noBorder summary__heading--savings">
					<span className="heading-2__text" style={{ color: savingsColor, display: 'flex', alignItems: 'center' }}>
						<span
							className="heading-2__img"
							style={{
								backgroundImage: `url(${savingsIcon})`,
								marginRight: '8px',
							}}
						></span>
						{savingsLabel}
					</span>
					<span className="summary__total" style={{ color: savingsColor }}>
						{savingsFormated}
					</span>
				</h2>
			</div>
		</div>
	);
};

export default OrderSummary;
